export default "__VITE_ASSET__BYTG3xE3__"